import { InfoCircle } from '#assets/ReactSvg.ts';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Link } from '#components/atoms/link/Link.tsx';

type Props = {
  className?: string;
};

/**
 * When there are no endpoint OIDC identity providers configured
 */
export function EmptyEndpointIdentityProvider({ className }: Props) {
  return (
    <Banner variant="info" Icon={InfoCircle} className={className}>
      No provider configured for endpoints.{' '}
      <Link className="a" to="/settings/sso/add?type=endpoint">
        Add provider
      </Link>
    </Banner>
  );
}
